import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '../utils/translations';
import AgentRegisterForm from '../components/AgentRegisterForm/AgentRegisterForm';
import './AdminRegisterPage.css';

const AdminRegisterPage = () => {
  const { theme } = useSelector((state) => state.ui);
  const { t } = useTranslation();

  return (
    <div className={`admin-register-page ${theme}`}>
      <div className="admin-register-container">
        <div className="admin-register-card">
          <div className="admin-register-header">
            <h1 className="admin-logo">Premium Homes</h1>
            <h2>{t('admin.register.title') || 'Add New Agent'}</h2>
            <p>{t('admin.register.adminOnly') || 'Only logged-in admins can create new agent accounts.'}</p>
          </div>
          <AgentRegisterForm showHeader={false} />
        </div>
      </div>
    </div>
  );
};

export default AdminRegisterPage;
